<p-toast></p-toast>
<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<!-- Top Bar: Breadcrumb, Filters, Pagination -->
<div class="card pt-2 pb-2 mb-3">
    <div class="flex justify-content-between align-items-center">
    </div>
</div>

<!-- Summary Cards -->
<div class="grid mb-4">
    <div class="col-12 md:col-6">
        <p-card header="Pending My Approval" styleClass="text-center">
            <div class="text-3xl font-bold text-orange-600">
                {{ expensesToApprove.length }}
            </div>
            <div class="text-sm text-500">Total expenses awaiting your review</div>
        </p-card>
    </div>
    <div class="col-12 md:col-6">
        <p-card header="Total Approved by Me (This Month)" styleClass="text-center">
            <div class="text-3xl font-bold text-green-600">
                {{ '0' }} <!-- Placeholder: requires fetching approved by user -->
            </div>
            <div class="text-sm text-500">Expenses you have approved recently</div>
        </p-card>
    </div>
</div>


<!-- Action and Filter Bar -->
<div class="flex justify-content-between align-items-center mb-3">
    <!-- Left side: Action Buttons -->
    <div class="flex align-items-center">
        <span class="p-input-icon-left mr-3">
            <i class="pi pi-search"></i>
            <input type="text" pInputText placeholder="Search..." (input)="applyFilterGlobal($event, 'contains')">
        </span>
        <p-button icon="pi pi-filter" label="Filters" styleClass="p-button-outlined mr-2"></p-button>
    </div>

    <!-- Right side: Filters and Search -->
    <div class="flex align-items-center">
        <!-- Search Input -->
        <span class="p-input-icon-left mr-3">
            <i class="pi pi-search"></i>
            <input type="text" pInputText placeholder="Search..." (input)="applyFilterGlobal($event, 'contains')">
        </span>
        <!-- Filters, Group By, Favorites (placeholders) -->
        <p-button icon="pi pi-filter" label="Filters" styleClass="p-button-outlined mr-2"></p-button>
        <p-button icon="pi pi-th-large" label="Group By" styleClass="p-button-outlined mr-2"></p-button>
        <p-button icon="pi pi-star" label="Favorites" styleClass="p-button-outlined"></p-button>
    </div>
</div>


<!-- Expense Approvals Table -->
<p-table #dt [value]="expensesToApprove" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
         currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10, 20, 50]"
         [globalFilterFields]="['expense.expenseNumber', 'expense.description', 'expense.submittedBy.name']"
         [lazy]="true" (onLazyLoad)="loadApprovalsLazy($event)" [totalRecords]="totalRecords"
         styleClass="p-datatable-gridlines p-datatable-sm" [tableStyle]="{'min-width': '50rem'}">

    <ng-template pTemplate="header">
        <tr>
            <th style="width: 3rem;">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th pSortableColumn="expense.submissionDate">Expense Date <p-sortIcon field="expense.submissionDate"></p-sortIcon></th>
            <th pSortableColumn="expense.expenseNumber">Reference <p-sortIcon field="expense.expenseNumber"></p-sortIcon></th>
            <th pSortableColumn="expense.description">Description <p-sortIcon field="expense.description"></p-sortIcon></th>
            <th pSortableColumn="expense.submittedBy.name">Submitted By <p-sortIcon field="expense.submittedBy.name"></p-sortIcon></th>
            <th pSortableColumn="expense.totalAmount" class="text-right">Total Amount <p-sortIcon field="expense.totalAmount"></p-sortIcon></th>
            <th class="text-center">Attachments</th>
            <th class="text-center">Current Status</th>
            <th style="width: 10rem;">Actions</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-expense>
        <tr>
            <td>
                <p-tableCheckbox [value]="expense"></p-tableCheckbox>
            </td>
            <td>{{ expense.createdAt | date:'shortDate' }}</td>
            <td>
                <a [routerLink]="['/expense/view', expense.expenseId]" class="text-primary-color hover:underline">
                    {{ expense.expenseNumber }}
                </a>
            </td>
            <td>{{ expense.description }}</td>
            <td>{{ expense.submittedBy?.name }}</td>
            <td class="text-right">{{ expense.totalAmount | currency:expense.currencyCode:'symbol':'1.2-2' }}</td>
            <td class="text-center">
                <span *ngIf="expense.attachments && expense.attachments.length > 0">
                    <i class="pi pi-paperclip mr-1"></i> ({{ expense.attachments.length }})
                </span>
                <span *ngIf="!expense.attachments || expense.attachments.length === 0">-</span>
            </td>
            <td class="text-center">
                <p-tag [value]="expense.status" [severity]="getStatusSeverity(expense.status)"></p-tag>
            </td>
            <td>
                <div class="flex justify-content-center">
                    <p-button icon="pi pi-check" styleClass="p-button-success mr-2" pTooltip="Approve" tooltipPosition="top"
                              (click)="openApprovalDialog(expense, 'Approved')"></p-button>
                    <p-button icon="pi pi-times" styleClass="p-button-danger" pTooltip="Reject" tooltipPosition="top"
                              (click)="openApprovalDialog(expense, 'Rejected')"></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="9" class="text-center">No expenses pending your approval.</td>
        </tr>
    </ng-template>
</p-table>

<!-- Approval/Rejection Dialog -->
<p-dialog [(visible)]="displayApprovalDialog" [modal]="true" [style]="{width: '50vw'}" header="Approve/Reject Expense">
    <div class="field">
        <label for="comments">Comments (Optional)</label>
        <textarea id="comments" pInputTextarea rows="3" [(ngModel)]="approvalComments" class="w-full"></textarea>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-secondary" (click)="displayApprovalDialog=false"></p-button>
        <p-button [label]="currentAction === 'Approved' ? 'Approve' : 'Reject'"
                  [icon]="currentAction === 'Approved' ? 'pi pi-check' : 'pi pi-times'"
                  [styleClass]="currentAction === 'Approved' ? 'p-button-success' : 'p-button-danger'"
                  (click)="confirmApprovalAction()"></p-button>
    </ng-template>
</p-dialog>
